import { FC } from 'react';

import { HeadingTagType } from '@purpur/library';
import { IconChevronDown } from '@purpur/library/icon/chevron-down';
import { IconChevronUp } from '@purpur/library/icon/chevron-up';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { ID, ORDER_CART_TEST_ID } from '../../constants';
import { ExpansionMode } from '../../model';
import { CartBoxHeader, ExpandButton, Title } from './CartHeader.styles';

type CartHeaderProps = {
    isExpanded?: boolean;
    onExpandClick?: () => void;
    title: string;
    titleTag?: HeadingTagType;
    expandable: ExpansionMode;
};

export const CartHeader: FC<CartHeaderProps> = ({ isExpanded, onExpandClick, expandable, title, titleTag = 'h2' }) => {
    const { t } = useTranslations();
    const Chevron = isExpanded ? IconChevronUp : IconChevronDown;

    return (
        <CartBoxHeader $expansionMode={expandable} data-test={ORDER_CART_TEST_ID.HEADER}>
            <Title id={ID.HEADING} tag={titleTag}>
                {title}
            </Title>

            <ExpandButton
                id={ID.HEADING_EXPAND_BTN}
                onClick={onExpandClick}
                aria-controls={ID.ENTRIES_LIST}
                aria-expanded={isExpanded}
            >
                {t[isExpanded ? 'order_cart.header.expand_btn.collapse' : 'order_cart.header.expand_btn.expand']}
                <Chevron size="xs" />
            </ExpandButton>
        </CartBoxHeader>
    );
};
